import { FC, SVGProps } from "react";

export const NewsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="m21.75 5v14c0 2.071-1.679 3.75-3.75 3.75h-12c-2.071 0-3.75-1.679-3.75-3.75v-14c0-2.071 1.679-3.75 3.75-3.75h12c2.071 0 3.75 1.679 3.75 3.75zm-1.5 0c0-1.243-1.007-2.25-2.25-2.25h-12c-1.243 0-2.25 1.007-2.25 2.25v14c0 1.243 1.007 2.25 2.25 2.25h12c1.243 0 2.25-1.007 2.25-2.25z" />
      <path d="m12 5.25c.414 0 .75.336.75.75s-.336.75-.75.75h-5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z" />
      <path d="m17 9.25c.414 0 .75.336.75.75s-.336.75-.75.75h-10c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z" />
      <path d="m17 13.25c.414 0 .75.336.75.75s-.336.75-.75.75h-10c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z" />
      <path d="m17 17.25c.414 0 .75.336.75.75s-.336.75-.75.75h-10c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z" />
    </g>
  </svg>
);
